<div class="create-workflows-demo">
  <!-- Header -->
  <h2 class="gradient-text fw-bold">Proba Workflows</h2>
  <p class="text-muted mb-4">
    Turn your forms, ID or company checks, and approvals into guided workflows that Proba runs for you.
  </p>

  <!-- Stats Bar -->
  <div class="row g-3 mb-3">
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-primary">
        <div class="card-body p-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="text-muted small">Control & Audit</span>
            <i class="fa fa-briefcase text-primary me-2"></i>
          </div>
          <div class="h4 fw-bold mb-0">Monitor</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-success">
        <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-muted small">Data Sync</span>
              <i class="fa fa-chart-line text-success me-2"></i>
            </div>
            <div class="h4 fw-bold mb-0">Live</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-danger">
        <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-muted small">Templates</span>
              <i class="fa fa-bullseye text-danger me-2"></i>
            </div>
            <div class="h4 fw-bold mb-0">Auto</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <div class="card h-100 border-0 rounded-4 shadow-lg border-0 border-top border-3 border-warning">
        <div class="card-body p-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="text-muted small">Workflows</span>
              <i class="fa fa-file-alt text-warning me-2"></i>
            </div>
            <div class="h4 fw-bold mb-0">Smart</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Workflow Cards Grid -->
  <div class="row g-4">
    <!-- Client Onboarding + KYC -->
    <div class="col-12 col-lg-6">
      <div class="workflow-card-new">
        <div class="workflow-content">
          <div class="d-flex align-items-start mb-2">
            <i class="fa fa-user-check gradient-text me-2 mt-1"></i>
            <h5 class="fw-bold mb-2">Client Onboarding</h5>
          </div>
          <p class="text-muted mb-3 small">
            Design digital onboarding forms, collect FICA/KYC documents, and automatically run ID, CIPC or other verification checks before routing cases to a compliance officer for approval.
          </p>
          <button class="btn upload-button text-white w-100" @click="launch_workspace('design')">
            <i class="fa fa-magic me-2"></i>Start Onboarding Workflow
          </button>
        </div>
      </div>
    </div>

    <!-- Supplier / Vendor Due Diligence -->
    <div class="col-12 col-lg-6">
      <div class="workflow-card-new">
        <div class="workflow-content">
          <div class="d-flex align-items-start mb-2">
            <i class="fa fa-building gradient-text me-2 mt-1"></i>
            <h5 class="fw-bold mb-2">Supplier & Vendor Due Diligence</h5>
          </div>
          <p class="text-muted mb-3 small">
            Onboard suppliers with structured questionnaires, document uploads and automated company checks.
          </p>
          <button class="btn upload-button text-white w-100" @click="launch_workspace('onboarding')">
            <i class="fa fa-magic me-2"></i>Start Vendor Workflow
          </button>
        </div>
      </div>
    </div>

    <!-- Automated Verification Queue -->
    <div class="col-12 col-lg-6 d-none">
      <div class="workflow-card-new">
        <div class="workflow-content">
          <div class="d-flex align-items-start mb-2">
            <i class="fa fa-shield-alt gradient-text me-2 mt-1"></i>
            <h5 class="fw-bold mb-2">Automated Verification Queue</h5>
          </div>
          <p class="text-muted mb-3 small">
            Stream IDs, company numbers or accounts into a single queue. Proba runs ID, CIPC or other verification services.
          </p>
          <button class="btn upload-button text-white w-100">
            <i class="fa fa-bolt me-2"></i>Configure Verification Flow
          </button>
        </div>
      </div>
    </div>

    <!-- Template Signing -->
    <div class="col-12 col-lg-6">
      <div class="workflow-card-new">
        <div class="workflow-content">
          <div class="d-flex align-items-start mb-2">
            <i class="fa fa-pen-fancy gradient-text me-2 mt-1"></i>
            <h5 class="fw-bold mb-2">Template Signing</h5>
          </div>
          <p class="text-muted mb-3 small">
            Use pre-approved templates for NDAs, contracts and agreements. Assign signers, track signature status and ensure compliance with version-controlled document workflows.
          </p>
          <button class="btn upload-button text-white w-100" @click="launch_workspace('signing')">
            <i class="fa fa-signature me-2"></i>Launch Signing Workflow
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
